<template>
  <div class="smartcard">
    <div class="row">
      <div class="col-sm-3">
        <h4>{{ rate.AccountType.name }}</h4>
        <p v-if="rate.CarClass">
          <span class="label" :class="randomLabel">{{ rate.CarClass.name }}</span>
        </p>
      </div>
      <div class="col-sm-3">
        <p><strong>Hourly:</strong> {{ rate.hourlyRate | to_dollar_amount }}</p>
        <p><strong>Daily:</strong> {{ rate.dailyRate | to_dollar_amount }}</p>
      </div>
      <div class="col-sm-3">
        <p><strong>Overnight:</strong> {{ rate.overnightRate | to_dollar_amount }}</p>
        <p><strong>Weekend:</strong> {{ rate.weekendRate | to_dollar_amount }}</p>
      </div>
    </div>
    <div class="toolbar text-right">
      <router-link v-if="isFinanceAdmin" class="btn btn-default"
      :to="'/membership/rates/vehicles/edit/' + rate.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button v-else disabled class="btn btn-default">
        <span class="fa fa-edit fa-fw"></span> Edit
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Rate',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    rate () {
      return {
        CarClass: {
          name: ''
        },
        AccountType: {
          name: ''
        },
        ...this.object
      }
    },
    ...mapGetters([
      'isFinanceAdmin'
    ]),
    randomLabel () {
      if (this.rate.CarClass) {
        let num = this.rate.CarClass.name.charCodeAt(0)
        return {
          'label-success': num % 5 === 0,
          'label-primary': num % 5 === 1,
          'label-danger': num % 5 === 2,
          'label-info': num % 5 === 3,
          'label-warning': num % 5 === 4
        }
      } else {
        return {}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/Rate.vue